import * as Yup from 'yup';
import { validateField, ValidationType } from './formValidation';
import { isValidPassword, PASSWORD_POLICY_MESSAGE } from 'utils/validations/password';
import type { LoginInterface, PasswordRecoveryInterface, ResetPasswordInterface } from 'types';

export const loginDefaultValues: LoginInterface = {
    email: '',
    password: '',
};

export const loginValidationSchema = Yup.object({
    email: validateField(ValidationType.EMAIL, true, 'Please enter a valid email address'),
    // Login only requires a non-empty password (policy is enforced on set/reset password).
    password: validateField(ValidationType.STRING, true, 'Please enter your password'),
});

export const passwordRecoveryDefaultValues: PasswordRecoveryInterface = {
    email: '',
};

export const passwordRecoveryValidationSchema = Yup.object({
    email: validateField(ValidationType.EMAIL, true, 'Please enter a valid email address'),
});

/** True when `email` is non-empty and passes Yup email validation (e.g. prefill checks). */
export const isValidEmail = (email: string): boolean =>
    Boolean(email?.trim()) && Yup.string().email().isValidSync(email.trim());

export const resetPasswordDefaultValues: ResetPasswordInterface = {
    password: '',
    confirmPassword: '',
};

export const resetPasswordValidationSchema = Yup.object({
    password: Yup.string()
        .required('This is a required field')
        .test('password-policy', PASSWORD_POLICY_MESSAGE, (value) =>
            value ? isValidPassword(value) : false
        ),
    confirmPassword: Yup.string()
        .required('This is a required field')
        .oneOf([Yup.ref('password')], 'Passwords must match'),
});
